export default {
  data() {
    return {
      isMobileViewport: false,
      _mediaQueryList: null,
    };
  },
  mounted() {
    this._mediaQueryList = window.matchMedia('(max-width: 768px)');

    this.isMobileViewport = this._mediaQueryList.matches;
    this._mediaQueryList.addListener(this._handleViewportChange);
  },
  beforeDestroy() {
    if (this._mediaQueryList) {
      this._mediaQueryList.removeListener(this._handleViewportChange);
    }
  },
  methods: {
    _handleViewportChange(event) {
      this.isMobileViewport = event.matches;
    },
  },
};